import Button from "@/components/bricks/button/Button";
import { useContext, useEffect, useState } from "react";
import OpretPersonIcon from "../../icons/OpretPersonIcon";
import PlusIcon from "../../icons/PlusIcon";
import Modal, {
  ModalContext,
  ModalProvider,
  ModalTrigger,
} from "../../Modal/Modal";
import { WizardReceipt } from "../common/wizardReceipt";
import { useOpretPerson } from "./useOpretPerson";
import Step1 from "./Step1";
import Step2 from "./Step2";
import { useNavigate } from "react-router-dom";
import { isArray, isObject } from "lodash";

const OpretPersonModal = () => {
  const { setModalOpen } = useContext(ModalContext);
  const navigate = useNavigate();
  const [isKoenManuallyChanged, setIsKoenManuallyChanged] = useState(false);
  const { step, setStep, step1, step2, opretPersonQuery } = useOpretPerson(
    setIsKoenManuallyChanged,
  );
  const { data, error, isPending } = opretPersonQuery;
  useEffect(() => {
    if (data && !error && !isPending && step === 3) {
      setTimeout(() => {
        setModalOpen(false);
        navigate("/person/" + data.id);
        step1.resetForm();
        step2.resetForm();
        setStep(1);
      }, 3000);
    }
  }, [
    data,
    error,
    navigate,
    setModalOpen,
    setStep,
    step,
    step1,
    step2,
    isPending,
  ]);
  const receiptHeading = isPending
    ? "Opretter person ..."
    : error
      ? "Kunne ikke oprette person"
      : data
        ? `${data.fornavne} ${data.efternavn} oprettet`
        : "What is this state?";

  return (
    <Modal
      dialog
      title={
        <>
          <OpretPersonIcon width={22} /> Opret ny person{" "}
          <span className="c-modal-steps">{step < 3 ? `${step} / 2` : ""}</span>
        </>
      }
      description=""
    >
      <div className="c-modal-container">
        {step === 1 && (
          <Step1
            isKoenManuallyChanged={isKoenManuallyChanged}
            setIsKoenManuallyChanged={setIsKoenManuallyChanged}
            setModalOpen={setModalOpen}
            step1={step1}
            step2={step2}
          />
        )}

        {step === 2 && <Step2 step1={step1} step2={step2} setStep={setStep} />}

        {step === 3 && (
          <>
            <WizardReceipt
              heading={receiptHeading}
              icon={isPending ? "loading" : data ? "success" : "warning"}
            >
              <p className="text-muted text-center">
                {error ? (
                  <Error error={error} />
                ) : isPending ? (
                  ""
                ) : (
                  "Henter den nye person ..."
                )}
              </p>
            </WizardReceipt>
            <div className="flex-100 d-flex justify-content-center mt-3">
              {!data && (
                <Button
                  color="secondary"
                  onClick={() => {
                    setStep(1);
                  }}
                >
                  Ret data
                </Button>
              )}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};

export default function OpretPerson() {
  return (
    <ModalProvider>
      <ModalTrigger asChild>
        <Button className="mx-3" transparent color="primary" onClick={() => {}}>
          <PlusIcon width={18} /> Opret person
        </Button>
      </ModalTrigger>
      <OpretPersonModal />
    </ModalProvider>
  );
}

function Error(props: { error: any }) {
  if (typeof props.error === "string") {
    return <>{props.error}</>;
  }
  if (props.error.data && props.error.data.Message) {
    return <>{props.error.data.Message}</>;
  }
  if (props.error.data && isObject(props.error.data.errors)) {
    return (
      <>
        {Object.entries(props.error.data.errors).map(([key, value]) => {
          return (
            <div key={key}>
              {key}:{" "}
              {isArray(value) ? (
                <ul>
                  {value.map((v, i) => (
                    <li key={i}>{v}</li>
                  ))}
                </ul>
              ) : typeof value === "string" || typeof value === "number" ? (
                value
              ) : (
                String(value)
              )}
            </div>
          );
        })}
      </>
    );
  }

  return (
    <div>
      <div>Ukendt errorformat, viser error objekt for debug</div>
      <pre>{JSON.stringify(props.error)}</pre>
    </div>
  );
}
